import { StudentFeedbackComponent } from './../../../../shared/src/lib/feature/student-feedback/student-feedback.component';
/**
 * Module pour mon Compte/Profil
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyaccountComponent } from './myaccount.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from '../../../../shared/src/lib/material.module';
import { TimezoneService } from '../../../../shared/src/lib/service/timezone.service';
import { ProInfoComponent } from './information/pro-info/pro-info.component';
import { DirectiveModule } from '../../../../shared/src/lib/directive/directive.module';
import { MomentModule } from 'ngx-moment';
import { RatingTeachersService } from '../../../../shared/src/lib/service/rating-teachers.service';
import { InformationComponent } from './information/information.component';
import { MyaccountRoutingModule } from './myaccount-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureModule } from '../../../../shared/src/lib/feature/feature.module';

@NgModule({
  imports: [
    CommonModule,
    MyaccountRoutingModule,
    FormsModule,
    FeatureModule,
    MaterialModule,
    ReactiveFormsModule,
    MomentModule,
    DirectiveModule,
    TranslateModule.forRoot(),
  ],
  declarations: [MyaccountComponent, ProInfoComponent, InformationComponent],
  providers: [TimezoneService, RatingTeachersService]
})
export class MyaccountModule { }
